module.exports = __webpack_public_path__ + "media/images/athletes/416-186b8f3f5437c7068b55db79cd8cb5a3.png";